var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnLike = function SvgUnLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.944 5H5.056C4.473 5 4 5.473 4 6.056v7.388c0 .583.473 1.056 1.056 1.056h1.888C7.527 14.5 8 14.027 8 13.444V6.056C8 5.473 7.527 5 6.944 5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m8 13.428 3.649 4.751a1.734 1.734 0 0 0 2.714.046v0c.265-.32.409-.725.409-1.14v-3.272h3.096a1.8 1.8 0 0 0 1.496-.799l.329-.49a1.8 1.8 0 0 0 .234-1.5l-1.359-4.722A1.8 1.8 0 0 0 16.839 5H10.55a1.8 1.8 0 0 0-1.318.574L8 6.9"
  })));
};
export { SvgUnLike as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiY2EwMzljYzA0ZDNkNDM2MDQ0NzZkMjFmNjEzNjAwNGYuc3ZnIjs=";